import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import LoadableComponent from "../Loading/LoadableComponent";
import TextField from "@material-ui/core/TextField";
import { Identifiable } from "../../models/Identifiable";
import { ExerciseGroup } from "../../models/ExerciseGroup";
import { GET_ALL_EXERCISE_GROUP, GET_EXERCISE_GROUP_BY_EXERCISE_AND_DATE } from "../../api/apiRoutes";
import getId from "../../utils/getId";
import getObjectIds from "../../utils/getObjectIds";
import useRequest from "../../utils/hook/requestHook";
import { get } from "../../api";
import { format } from "date-fns";

interface IProps {
  exerciseGroup: Identifiable;
  setExerciseGroup: (exerciseGroupIds: Identifiable) => void;
  date?: Date;
}

const ExerciseGroupSelector: React.FC<IProps> = ({ exerciseGroup, setExerciseGroup, date }) => {
  const [data, loading] = useRequest<ExerciseGroup[]>(
    async (signal: AbortSignal) =>
      await get(
        GET_EXERCISE_GROUP_BY_EXERCISE_AND_DATE(date ? format(date, "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd")),
        signal
      )
  );

  return (
    <LoadableComponent loading={loading}>
      <TextField
        variant="outlined"
        select
        fullWidth
        margin={"dense"}
        label={"Wybierz grupę"}
        value={getId(exerciseGroup)}
        onChange={(e) =>
          setExerciseGroup({
            objectDb: getObjectIds(e.target.value) ? Number(getObjectIds(e.target.value)?.objectDb) : 0,
            objectId: getObjectIds(e.target.value) ? Number(getObjectIds(e.target.value)?.objectId) : 0,
          } as Identifiable)
        }
      >
        <MenuItem value={"0,0"}>Wszystkie</MenuItem>
        {data?.map((item) => (
          <MenuItem key={item.objectId} value={getId(item)}>
            {item.name}
          </MenuItem>
        ))}
      </TextField>
    </LoadableComponent>
  );
};

export default ExerciseGroupSelector;
